import { useEffect } from "react";

/**
 * Inject a JSON-LD <script> into <head> for the lifetime of the mounted
 * component (page). Automatically removes on unmount to avoid duplication
 * across client-side navigations.
 *
 * @param {object|object[]} data - Schema.org object or array of objects
 * @param {string} id - Unique DOM id for the script tag (per page)
 */
export function useJsonLd(data, id) {
  useEffect(() => {
    if (!data || !id) return;
    // Remove any pre-existing tag with the same id (hot reload / re-mount)
    const existing = document.getElementById(id);
    if (existing) existing.remove();

    const script = document.createElement("script");
    script.type = "application/ld+json";
    script.id = id;
    script.text = JSON.stringify(data);
    document.head.appendChild(script);

    return () => {
      const el = document.getElementById(id);
      if (el) el.remove();
    };
  }, [data, id]);
}
